import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { debounce } from "lodash";
import { useState } from "react";
import { UseFormRegister, type UseFormWatch } from "react-hook-form";
import type { IExhibitorInvoiceList } from "src/content/modules/exhibitor/type/exhibitorType";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
// Define the Country type

const InvoiceVisitorSelectFieldList = ({
	register,
	fieldName,
	label,
	hideCustomLabel,
	isRequired,
	mt,
	onChange,
	defaultValue,
	watch,
}: {
	register?: UseFormRegister<any>;
	fieldName: string;
	label?: string;
	hideCustomLabel?: boolean;
	isRequired?: boolean;
	mt?: "0";
	onChange?: (e: number) => void;
	defaultValue?: {
		country_id: number;
		country_name: string;
	};
	watch?: UseFormWatch<any>;
}) => {
	const visitor_id = watch("visitor_id");
	const [search, setSearch] = useState("");
	const { data, isLoading } = useGetQueryWithTotal<IExhibitorInvoiceList[]>({
		endPoint: "/api/admin/visitor/invoice",
		queryKeys: ["Exhibitor", search],
		params: {
			invoice_no: search,
			status: "unpaid",
			visitor_id,
		},
	});
	// Fetch country data from the API

	return (
		<Box sx={{ mt: mt ? 0 : 2 }}>
			{!hideCustomLabel && (
				<label>
					{label}{" "}
					{isRequired && <span style={{ color: "red" }}>*</span>}
				</label>
			)}

			<Autocomplete
				// defaultValue={defaultValue || null}
				disabled={!visitor_id}
				options={data?.data || []}
				getOptionLabel={(option: IExhibitorInvoiceList) =>
					`${option?.invoice_no}-(${option.due})`
				}
				onInputChange={debounce((_, value) => {
					setSearch(value);
				}, 300)}
				onChange={(_, value: IExhibitorInvoiceList) => {
					register &&
						register(fieldName).onChange({
							target: {
								name: fieldName,
								value: value ? value.id : "",
							},
						});
					if (value?.id) {
						onChange && onChange(value?.id);
					}
				}}
				isOptionEqualToValue={(option, value) =>
					option?.id === value?.id
				}
				loading={isLoading}
				clearIcon={
					<span
						onClick={() => {
							setSearch("");
						}}
					>
						<ClearIcon fontSize='small' />
					</span>
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='Enter Invoice'
						required={isRequired}
						label={hideCustomLabel ? label : ""}
						variant='outlined'
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress
											color='inherit'
											size={20}
										/>
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default InvoiceVisitorSelectFieldList;
